var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 15.6C12.7732 15.6 13.4 16.2268 13.4 17C13.4 17.7732 12.7732 18.4 12 18.4C11.2268 18.4 10.6 17.7732 10.6 17C10.6 16.2268 11.2268 15.6 12 15.6ZM12.0736 6C12.3112 6 12.4604 6.03713 12.5907 6.10685C12.7211 6.17658 12.8234 6.27889 12.8931 6.40926C12.9629 6.53963 13 6.68878 13 6.92638V13.0736C13 13.3112 12.9629 13.4604 12.8931 13.5907C12.8234 13.7211 12.7211 13.8234 12.5907 13.8931C12.4604 13.9629 12.3112 14 12.0736 14H11.9264C11.6888 14 11.5396 13.9629 11.4093 13.8931C11.2789 13.8234 11.1766 13.7211 11.1069 13.5907C11.0371 13.4604 11 13.3112 11 13.0736V6.92638C11 6.68878 11.0371 6.53963 11.1069 6.40926C11.1766 6.27889 11.2789 6.17658 11.4093 6.10685C11.5396 6.03713 11.6888 6 11.9264 6H12.0736Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1fffd9bd488c59dd976e7c263b1db7e9.svg";
export { ForwardRef as ReactComponent };